import React, { useState, useEffect, useContext } from 'react'
import ProductsSoldHeader from './ProductsSoldHeader'
import ProductsSoldInner from './ProductsSoldInner'
import ProductsSoldFooter from './ProductsSoldFooter'
import { appContext } from '../../../../../../App'
import { getProductsSoldReport } from '../../../../ReportsFunctions'

export const productsSoldContext = React.createContext()

function useProductsSoldController(props) {
  const app = useContext(appContext)
  const [date, setDate] = useState({
    from: new Date(app.getClientDateTime()).getFullYear() + '-01-01',
    to: new Date(app.getClientDateTime()).getFullYear() + '-12-31'
  })

  const [productsSold, setProductsSold] = useState(null)

  useEffect(() => {
    const reloadProductsSold = async () => { setProductsSold(await getProductsSoldReport(app, date)) }

    reloadProductsSold()
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date])

  const obj = {
    app,
    productsSold: [productsSold, setProductsSold],
    date: [date, setDate]
  }

  return (obj)
}

function ProductsSoldController(props) {
  const productsSoldController = useProductsSoldController(props)
  return (
    <React.Fragment>
      <productsSoldContext.Provider value={productsSoldController}>
        <ProductsSoldHeader />
        <ProductsSoldInner />
        <ProductsSoldFooter />
      </productsSoldContext.Provider>
    </React.Fragment>
  )
}

export default React.memo(ProductsSoldController)